export default "__VITE_PUBLIC_ASSET__b16d12a8__"